import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setTokenDetails } from '../Store/AuthSlice';
import { Spinner } from '@fluentui/react-components';
import { useGetBasicStorefrontQuery, useGetSessionQuery } from '../Api/Api';
import { SK_FIRST_NAME, SK_LAST_NAME, SK_ORGANIZATION, SK_STOREFRONT, SK_TOKEN } from '../Constants/LocalStorageKeys';
import { useLocalizationUnauthenticated } from '../Components/Helpers/useLocalization';
import LoginPageShell from '../Components/Auth/LoginPageShell';

const StorefrontTokenPage: React.FC = () => {
    const L = useLocalizationUnauthenticated();
    // Get token from query string
    const token = new URLSearchParams(window.location.search).get('token');
    const redirect = new URLSearchParams(window.location.search).get('redirect');
    // get token details
    const session = useGetSessionQuery({token: token ?? undefined})
    // Only to pick up the storefront's auth-page styling, so this landing page matches the sign-in the
    // shopper just came from. The storefront is whichever one this browser last saw — the same source
    // useLocalizationUnauthenticated uses — because the token URL carries no storefront of its own.
    const org = localStorage.getItem(SK_ORGANIZATION) ?? '';
    const sf = localStorage.getItem(SK_STOREFRONT) ?? '';
    const sSettings = useGetBasicStorefrontQuery({ organization: org, storefront: sf }, { skip: !org || !sf });
    const dispatch = useDispatch();
    const navigate = useNavigate();

    React.useEffect(() => {
        if (token && session.isSuccess && session.data) {
            dispatch(setTokenDetails({token, details: session.data}));
            // save token, organization, and storefront to localstorage
            localStorage.setItem(SK_TOKEN, token);
            localStorage.setItem(SK_ORGANIZATION, session.data.organization);
            localStorage.setItem(SK_STOREFRONT, session.data.storefront);
            localStorage.setItem(SK_FIRST_NAME, session.data.firstName);
            localStorage.setItem(SK_LAST_NAME, session.data.lastName);
            // Redirect to storefront page
            if (redirect) {
                const sanitizedRedirect = redirect.startsWith('/') ? redirect : `/${redirect}`;
                navigate(sanitizedRedirect);
            }
            else navigate(`/home`);
        }
    }, [token, dispatch, navigate, session.isSuccess, session.data, redirect])


    return (
        <LoginPageShell config={sSettings.data?.loginPageConfig} storefrontName={sSettings.data?.name} favicon={sSettings.data?.favicon}>
            <Spinner label={L('localization_common_loading')} />
        </LoginPageShell>
    );
}

export default StorefrontTokenPage;